import axios from "../../http/axios";
import * as actionTypes from "./actionTypes";
export const GET_FINANCE_RESTAURANTS = "GET_FINACE_RESTAURANTS";
export const GET_SEARCH_FINANCE_RESTAURANTS = "GET_SEARCH_FINACE_RESTAURANTS";
export const DOWNLOAD_FINACE_RESTAURANTS = "DOWNLOAD_FINACE_RESTAURANTS";

export function getFinanceRestaurants(token, page) {
  const request = axios.get(`/reports-restaurant-finance/?page=${page}`, {
    headers: { Authorization: "JWT " + token }
  });
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_FINANCE_RESTAURANTS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function getSearchFinanceRestaurants(token, from, to, value) {
  const request = axios.get(
    `/reports-restaurant-finance/?${from ? `from_date=${from}` : ""}${
      to ? `&to_date=${to}` : ""
    }${value ? `&search=${value}` : ""}`,
    {
      headers: { Authorization: "JWT " + token }
    }
  );
  return dispatch =>
    request
      .then(res =>
        dispatch({
          type: GET_SEARCH_FINANCE_RESTAURANTS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
}
export function downloadFinanceRestaurants(token, from, to, value) {
  const request = axios.get(
    `/reports-restaurant-finance/?${from ? `from_date=${from}` : ""}${
      to ? `&to_date=${to}` : ""
    }${value ? `&search=${value}` : ""}&show_all=true `,
    {
      headers: { Authorization: "JWT " + token, Accept: "text/csv" },
      responseType: "blob"
    }
  );
  return dispatch => {
    return request
      .then(res =>
        dispatch({
          type: DOWNLOAD_FINACE_RESTAURANTS,
          payload: res.data
        })
      )
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/financeRestaurants.js